import React, { createContext, useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import Overview from "../Overview";
import Plans from "../Plans";
import SinglePlan from "../SinglePlan";

import Navbar from "../../Components/Navbar";
import { AppContextProps } from "../../Context/AppContext";
import { Endpoints } from "../../Lib/Endpoints";
import { NonPaginatedResponse } from "../../Lib/Responses";
import { AdminProfileProps } from "../../Lib/Types";
import { usePerformRequest } from "../../Lib/usePerformRequest";
import PendingSubscriptions from "../PendingSubscriptions";
import TransactionsPage from "../Transactions";

import Subscriptions from "../Subscriptions";
import UsersPage from "../Users";
import "./styles.scss";
import Team from "../Team";
import SupportTickets from "../SupportTickets";
import SingleSubscriptionPage from "../SingleSubscription";
import PromotersPage from "../Promoters";
import SinglePromoter from "../SinglePromoter";
import SingleUser from "../SingleUser";
import OfflinePaymentsPage from "../OfflinePayments";

export const AppContext = createContext<AppContextProps | undefined>(undefined);

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const {
    data: adminProfile,
    response: adminProfileResponse,
    reloadData: reloadAdminProfile,
    isLoading: isLoadingProfile,
  } = usePerformRequest<NonPaginatedResponse<AdminProfileProps>>({
    method: "GET",
    route: Endpoints.GetAdminProfile(),
  });

  useEffect(() => {
    if (adminProfileResponse && adminProfileResponse.status) {
      if (adminProfileResponse.status !== 200) {
        navigate("/login");
      }
    }
  }, [isLoadingProfile, adminProfileResponse]);

  const LogoutAdmin = async () => {
    localStorage.removeItem("t");
    navigate("/login");
  };
  return (
    <AppContext.Provider
      value={{
        logout: LogoutAdmin,
        profile: adminProfile?.data,
        isLoadingProfile,
        reloadAdminProfile: reloadAdminProfile,
      }}
    >
      <div className="dashboard-container">
        <Navbar />
        <Routes>
          <Route index path="/" element={<Overview />} />
          <Route path="/plans" element={<Plans />} />
          <Route path="/plan/:planID" element={<SinglePlan />} />
          <Route path="/transactions" element={<TransactionsPage />} />
          <Route path="/subscriptions" element={<Subscriptions />} />
          <Route
            path="/subscription/:subscriptionID"
            element={<SingleSubscriptionPage />}
          />
          <Route path="/temps" element={<PendingSubscriptions />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/user/:userID" element={<SingleUser />} />
          <Route path="/promoters" element={<PromotersPage />} />
          <Route path="/promoter/:userID" element={<SinglePromoter />} />
          <Route path="/team" element={<Team />} />
          <Route path="/support" element={<SupportTickets />} />
          <Route path="/offline-payments" element={<OfflinePaymentsPage />} />
        </Routes>
      </div>
    </AppContext.Provider>
  );
};
export default Dashboard;
